import { render, staticRenderFns } from "./AddToCart.vue?vue&type=template&id=5296ddd1&scoped=true"
import script from "./AddToCart.vue?vue&type=script&lang=js"
export * from "./AddToCart.vue?vue&type=script&lang=js"
import style0 from "./AddToCart.vue?vue&type=style&index=0&id=5296ddd1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5296ddd1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FixitDialog: require('/salonhomepage/client/components/FixitDialog.vue').default})
